(function ($) {

    //$('.woocommerce-form-login__submit').prop('disabled', true);

    // Perform AJAX login/register on form submit
    /*$('form#login, form#register').on('submit', function (e) {
        //if (!$(this).valid()) return false;

        $(this).addClass('loading');

        action = 'ajaxlogin';
        username = 	$('form#login #username').val();
        password = $('form#login #password').val();
        email = '';
        security = $('form#login #woocommerce-login-nonce').val();

        if ($(this).attr('id') == 'register') {
            action = 'ajaxregister';
            username = $('#signonname').val();
            password = $('#signonpassword').val();
            email = $('#email').val();
            security = $('#signonsecurity').val();
        }
        ctrl = $(this);

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: scwcWpAjax.ajaxurl,
            data: {
                'action': action,
                'username': username,
                'password': password,
                'email': email,
                'security': security
            },
            success: function (data) {
                $(this).removeClass('loading');

                if (data.loggedin === true) {
                    document.location.href = scwcWpAjax.redirecturl;
                }
            }
        });
        e.preventDefault();
    });
*/
})(jQuery);